import styled from 'styled-components';

export const HeadingWrapper = styled.div`
    padding: 5px 0px 15px 10px;
    border-bottom: 1px solid #b5b5b5;
`;
